const $ = jQuery.noConflict();
class SliderImageText {
    constructor(sliderImageWrap, infoWrapperContent, nextSlide) {
        this.sliderImageWrap = sliderImageWrap;
        this.infoWrapperContent = infoWrapperContent;
        this.nextSlide = nextSlide;
    }
    init() {
        this.initSlider();
        $(this.nextSlide).on('click', () => {
            $(this.sliderImageWrap).slick('slickNext');
            $(this.infoWrapperContent).slick('slickNext');
        });
    }
    initSlider() {
        const slickSettingsImg = {
            dots: false,
            arrows: false,
            speed: 300,
            slidesToShow: 1,
            draggable: false,
            asNavFor: '.info-wrapper__content'
        }
        const slickSettingsTxt = {
            dots: false,
            arrows: false,
            speed: 300,
            slidesToShow: 1,
            draggable: false,
            asNavFor: '.slider-image-wrap'
        }
        $(this.sliderImageWrap).slick(slickSettingsImg);
        $(this.infoWrapperContent).slick(slickSettingsTxt);


    }
}

export default new SliderImageText('.slider-image-wrap', '.info-wrapper__content', '.next-slide');